import * as React from "react";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import { DialogContentText, InputAdornment } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import _ from "lodash";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import GetCurrency from "../../helper/GetCurrency";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { _post } from "../../Api";
import { toast } from "react-toastify";
import Grid from "@material-ui/core/Grid";
import { tc_invoice_types, tc_periods } from "../Subscriptions/TCountSubscriptions/TCountSubscriptions";
import { qr_invoice_types, qr_periods } from "../Subscriptions/TAQRSubscriptions/TAQRSubscriptions";
import { ta_invoice_types, ta_periods } from "../Subscriptions/TAmountSubscriptions/TAmountSubscriptions";
import { pillar_invoice_types, pillar_periods } from "../Subscriptions/PillarSubscriptions/PillarSubscriptions";
import { paymentOptions } from "../PaymentDialog/PaymentDialog";

export default function AddSubscriptionDialog(props) {
  const [onceSubscription, setOnceSubscription] = React.useState(null);
  const [qrSubscription, setQrSubscription] = React.useState(null);
  const [tcSubscription, setTcSubscription] = React.useState(null);
  const [taSubscription, setTaSubscription] = React.useState(null);
  const [pillarSubscription, setPillarSubscription] = React.useState(null);
  const currentMerchant = props.merchant;
  const [tspMerchants, setTspMerchants] = React.useState(null);
  const merchantId = currentMerchant.id;
  const default_vat_value = 21;
  const toast_values = {
    position: "bottom-right",
    autoClose: 2000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  // loading circle when retrieving data from cloudstore
  const load = () => {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  };

  /**
   * This enables the payment dialog to select payment options in case the type === 'PAYNL_TRANSACTION_COUNT'
   * paymentMode is a parent prop from src/screens/Subscriptions.js
   */
  const openPaymentDialog = () => props.setPaymentMode("add");

  /**
   * This method is to clear all fields when the user clicks on the cancel button to close the 'add' dialog
   */
  const initializeAll = () => {
    initializeOnce();
    initializeQR();
    initializeTA("TA_TA");
    initializeTC("TA_TC");
    initializePillar("PILLAR_USER");
  };

  /**
   * This method loads all types of merchants:
   * - TA merchants
   * - SP merchants
   * - Pillar merchants
   */
  const loadTspMerchants = () => {
    const ta_merchants = [...currentMerchant.ta_merchants.map((ta_merchant) => "T" + ta_merchant.id)];
    const sp_merchants = [...currentMerchant.sp_merchants.map((sp_merchant) => "S" + sp_merchant.id)];
    const pillar_merchants = currentMerchant.pillar_merchants
      ? [...currentMerchant.pillar_merchants.map((pillar_merchant) => "P" + pillar_merchant.id)]
      : [];
    const merchants = [...ta_merchants, ...sp_merchants, ...pillar_merchants];
    setTspMerchants(merchants);
  };

  /**
   * Callback when the user clicks on the cancel button
   */
  const closeDialog = () => {
    initializeAll();
    props.setDialogType(null);
  };

  // initialize functions

  /**
   * Initialize once type subscription -> React state is loaded with empty once object
   */
  const initializeOnce = () => {
    setOnceSubscription({
      debtor_code: "",
      debtor_name: "",
      wefact_merchant_id: "",
      title: "",
      date: "",
      number: "",
      type: "",
      price: "",
      tsp_merchant_id: "",
    });
  };

  /**
   * Initialize QR type subscription -> React state is loaded with empty QR object
   * @param type = TA_QR || SP_QR
   */
  const initializeQR = (type) => {
    const key_merchant_id = type === "TA_QR" ? "ta_merchant_id" : "sp_merchant_id";
    setQrSubscription({
      [key_merchant_id]: "",
      type: type,
      wefact_merchant: {
        id: "",
      },
      name: "",
      subscription_started: "",
      subscription_stopped: "",
      period: "",
      invoice_type: "",
      meta: {
        price_per_qr: null,
        number_of_qrs: null,
        number_suffix: null,
        discount_percentage: null,
      },
    });
  };

  /**
   * Initialize Transaction Count (TC) type subscription -> React state is loaded with empty TC object
   * @param type = TA_TC || SP_TC || PAYNL_TC
   */
  const initializeTC = (type) => {
    const mapping = {
      TA_TC: "ta_merchant_id",
      SP_TC: "sp_merchant_id",
      PAYNL_TC: "ta_merchant_id",
    };
    const key_merchant_id = mapping[type];
    setTcSubscription({
      [key_merchant_id]: "",
      type: type,
      wefact_merchant_id: "",
      name: "",
      subscription_started: "",
      subscription_stopped: "",
      period: "",
      invoice_type: "",
      count_price: "",
      vat: 21,
    });
  };

  /**
   * Initialize Transaction Amount (TA) type subscription -> React state is loaded with empty TA object
   * @param type = TA_TA || SP_TA
   */
  const initializeTA = (type) => {
    const mapping = {
      TA_TA: "ta_merchant_id",
      SP_TA: "sp_merchant_id",
    };
    const key_merchant_id = mapping[type];
    setTaSubscription({
      [key_merchant_id]: "",
      type: type,
      wefact_merchant_id: "",
      name: "",
      subscription_started: "",
      subscription_stopped: "",
      period: "",
      invoice_type: "",
      amount_price: "",
      vat: default_vat_value,
    });
  };

  /**
   * Initialize Pillar type subscription -> React state is loaded with empty Pillar object
   * @param type = PILLAR_USER
   */
  const initializePillar = (type) => {
    setPillarSubscription({
      pillar_merchant_id: "",
      type: type,
      wefact_merchant_id: "",
      name: "",
      subscription_started: "",
      subscription_stopped: "",
      period: "",
      invoice_type: "",
      number_suffix: "",
      price_per_pillar_user: "",
      number_of_pillar_users: "",
    });
  };

  // change functions

  /**
   * Change a property of a once subscription
   * @param key of once subscription
   * @param value newly assigned value
   */
  const changeOnce = (key, value) => {
    if (key === "debtor_code") {
      onceSubscription.debtor_code = value;
      const wefactMerchant = props.wefactMerchants.find((x) => x.debtor_code === value);
      onceSubscription.debtor_name = wefactMerchant.name;
      onceSubscription.wefact_merchant_id = wefactMerchant.id;
    } else {
      onceSubscription[key] = value;
    }
    setOnceSubscription(_.cloneDeep(onceSubscription));
  };
  /**
   * Change a property of a QR subscription
   * @param key of QR subscription
   * @param value newly assigned value
   */
  const changeQR = (key, value) => {
    const qr_sub = _.cloneDeep(qrSubscription);
    if (key === "wefact_merchant") {
      qr_sub["wefact_merchant"].id = props.wefactMerchants.find((merchant) => merchant.id === value).id;
    } else if (key.includes("meta")) {
      qr_sub["meta"][key.replace("meta ", "")] = value;
    } else {
      qr_sub[key] = value;
    }
    setQrSubscription(qr_sub);
  };
  /**
   * Change a property of a TC subscription
   * @param key of TC subscription
   * @param value newly assigned value
   */
  const changeTC = (key, value) => {
    const tc_sub = _.cloneDeep(tcSubscription);
    if (key === "paynl_merchant") {
      const type = value[0];
      const id = value.slice(1);
      const mapping = {
        T: "ta_merchant_id",
        S: "sp_merchant_id",
      };
      tc_sub[mapping[type]] = id;
      if (type === "T") {
        delete tc_sub["sp_merchant_id"];
      } else {
        delete tc_sub["ta_merchant_id"];
      }
    } else if (key === "wefact_merchant_id") {
      tc_sub["wefact_merchant_id"] = props.wefactMerchants.find((merchant) => merchant.id === value).id;
    } else {
      tc_sub[key] = value;
    }
    setTcSubscription(tc_sub);
  };
  /**
   * Change a property of a TA subscription
   * @param key of TA subscription
   * @param value newly assigned value
   */
  const changeTA = (key, value) => {
    const ta_sub = _.cloneDeep(taSubscription);
    if (key === "wefact_merchant_id") {
      ta_sub["wefact_merchant_id"] = props.wefactMerchants.find((merchant) => merchant.id === value).id;
    } else {
      ta_sub[key] = value;
    }
    setTaSubscription(ta_sub);
  };

  /**
   * Change a property of a Pillar subscription
   * @param key of Pillar subscription
   * @param value newly assigned value
   */
  const changePillar = (key, value) => {
    const pillar_sub = _.cloneDeep(pillarSubscription);
    if (key === "wefact_merchant_id") {
      pillar_sub["wefact_merchant_id"] = props.wefactMerchants.find((merchant) => merchant.id === value).id;
    } else {
      pillar_sub[key] = value;
    }
    setPillarSubscription(pillar_sub);
  };

  // add functions

  const addOnce = () => {
    if (Object.keys(onceSubscription).some((key) => onceSubscription[key] === "")) {
      toast.error("Not all fields are filled out", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    let merchant_id_type;
    switch (onceSubscription.tsp_merchant_id[0]) {
      case "T":
        merchant_id_type = "ta_merchant_id";
        break;
      case "S":
        merchant_id_type = "sp_merchant_id";
        break;
      case "P":
        merchant_id_type = "pillar_merchant_id";
        break;
      default:
        console.error("Selected merchant can be only TA, SP or Pillar merchant.");
    }
    _post("/nova/merchant/" + merchantId + "/subscription", {
      type: "ONCE",
      date: onceSubscription.date,
      name: onceSubscription.title,
      price: onceSubscription.price,
      number: parseInt(onceSubscription.number),
      number_suffix: onceSubscription.type,
      wefact_merchant_id: onceSubscription.wefact_merchant_id,
      [merchant_id_type]: parseInt(onceSubscription.tsp_merchant_id.slice(1)),
    })
      .then((response) => {
        toast.success("New once subscription added!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log(response.data);
        props.subscriptions.push(response.data);
        props.setSubscriptions(_.cloneDeep(props.subscriptions));
        closeDialog();
      })
      .catch((error) => {
        toast.error("New once subscription could not be added.", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.error(error);
        return Promise.reject(error);
      });
  };

  const addQR = () => {
    if (
      Object.keys(qrSubscription).some(
        (key) => qrSubscription[key] === "" && key !== "meta" && key !== "subscription_stopped"
      )
    ) {
      toast.error("Not all mandatory fields are filled out", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    if (new Date(qrSubscription["subscription_started"]) > new Date(qrSubscription["subscription_stopped"])) {
      toast.error("End date should be after start date", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    _post("/nova/merchant/" + merchantId + "/subscription", {
      [qrSubscription.type === "TA_QR" ? "ta_merchant_id" : "sp_merchant_id"]:
        qrSubscription.type === "TA_QR" ? qrSubscription["ta_merchant_id"] : qrSubscription["sp_merchant_id"],
      type: qrSubscription.type,
      wefact_merchant_id: qrSubscription.wefact_merchant.id,
      name: qrSubscription.name,
      subscription_started: qrSubscription.subscription_started,
      subscription_stopped: qrSubscription.subscription_stopped === "" ? null : qrSubscription.subscription_stopped,
      period: qrSubscription.period,
      invoice_type: qrSubscription.invoice_type,
      price_per_qr: qrSubscription.meta.price_per_qr,
      number_of_qrs: qrSubscription.meta.number_of_qrs,
      number_suffix: qrSubscription.meta.number_suffix,
      discount_percentage: qrSubscription.meta.discount_percentage,
    })
      .then((response) => {
        toast.success("New " + qrSubscription.type + " subscription added!", toast_values);
        console.log(response.data);
        props.subscriptions.push(response.data);
        props.setSubscriptions(_.cloneDeep(props.subscriptions));
        closeDialog();
      })
      .catch((error) => {
        toast.error("New " + qrSubscription.type + " subscription could not be added.", toast_values);
        console.error(error);
        return Promise.reject(error);
      });
  };

  const addTC = () => {
    setTcSubscription(props.paymentSub);
    if (
      Object.keys(tcSubscription).some(
        (key) => tcSubscription[key] === "" && key !== "count_price" && key !== "subscription_stopped" && key !== "vat"
      )
    ) {
      toast.error("Not all mandatory fields are filled out", toast_values);
      return;
    }
    if (
      tcSubscription["subscription_stopped"] &&
      new Date(tcSubscription["subscription_started"]) > new Date(tcSubscription["subscription_stopped"])
    ) {
      toast.error("End date should be after start date", toast_values);
      return;
    }
    const mapping = {
      TA_TC: "TA_TRANSACTION_COUNT",
      SP_TC: "SP_TRANSACTION_COUNT",
      PAYNL_TC: "PAYNL_TRANSACTION_COUNT",
    };
    const postdata = {
      type: mapping[tcSubscription.type],
      wefact_merchant_id: tcSubscription.wefact_merchant_id,
      name: tcSubscription.name,
      subscription_started: tcSubscription.subscription_started,
      subscription_stopped: tcSubscription.subscription_stopped === "" ? null : tcSubscription.subscription_stopped,
      period: tcSubscription.period,
      invoice_type: tcSubscription.invoice_type,
      vat: tcSubscription.vat / 100,
    };
    if (tcSubscription.type === "PAYNL_TC") {
      postdata["payment_methods"] = {};
      for (let paymentOption of paymentOptions) {
        if (tcSubscription[paymentOption]) {
          postdata["payment_methods"][paymentOption] = tcSubscription[paymentOption];
        }
      }
    } else {
      postdata["count_price"] = tcSubscription["count_price"];
    }
    if (tcSubscription.sp_merchant_id) postdata.sp_merchant_id = parseInt(tcSubscription.sp_merchant_id);
    if (tcSubscription.ta_merchant_id) postdata.ta_merchant_id = parseInt(tcSubscription.ta_merchant_id);
    _post("/nova/merchant/" + merchantId + "/subscription", postdata)
      .then((response) => {
        toast.success("New " + tcSubscription.type + " subscription added!", toast_values);
        console.log(response.data);
        props.subscriptions.push(response.data);
        props.setSubscriptions(_.cloneDeep(props.subscriptions));
        closeDialog();
      })
      .catch((error) => {
        toast.error("New " + tcSubscription.type + " subscription could not be added.", toast_values);
        console.error(error);
        return Promise.reject(error);
      });
  };

  const addTA = () => {
    if (
      Object.keys(taSubscription).some(
        (key) => taSubscription[key] === "" && key !== "amount_price" && key !== "subscription_stopped" && key !== "vat"
      )
    ) {
      toast.error("Not all mandatory fields are filled out", toast_values);
      return;
    }
    if (
      taSubscription["subscription_stopped"] &&
      new Date(taSubscription["subscription_started"]) > new Date(taSubscription["subscription_stopped"])
    ) {
      toast.error("End date should be after start date", toast_values);
      return;
    }
    const mapping = {
      TA_TA: "TA_TRANSACTION_AMOUNT",
      SP_TA: "SP_TRANSACTION_AMOUNT",
    };
    const postdata = {
      type: mapping[taSubscription.type],
      wefact_merchant_id: taSubscription.wefact_merchant_id,
      name: taSubscription.name,
      subscription_started: taSubscription.subscription_started,
      subscription_stopped: taSubscription.subscription_stopped === "" ? null : taSubscription.subscription_stopped,
      period: taSubscription.period,
      invoice_type: taSubscription.invoice_type,
      amount_price: taSubscription.amount_price === "" ? null : taSubscription.amount_price,
      vat: taSubscription.vat / 100,
    };
    if (taSubscription.sp_merchant_id) postdata.sp_merchant_id = parseInt(taSubscription.sp_merchant_id);
    if (taSubscription.ta_merchant_id) postdata.ta_merchant_id = parseInt(taSubscription.ta_merchant_id);
    if (taSubscription.amount_price) postdata.amount_price = parseFloat(taSubscription.amount_price);
    _post("/nova/merchant/" + merchantId + "/subscription", postdata)
      .then((response) => {
        toast.success("New " + taSubscription.type + " subscription added!", toast_values);
        console.log(response.data);
        props.subscriptions.push(response.data);
        props.setSubscriptions(_.cloneDeep(props.subscriptions));
        closeDialog();
      })
      .catch((error) => {
        toast.error("New " + taSubscription.type + " subscription could not be added.", toast_values);
        console.error(error);
        return Promise.reject(error);
      });
  };

  const addPillar = () => {
    if (
      Object.keys(pillarSubscription).some(
        (key) =>
          pillarSubscription[key] === "" &&
          key !== "number_suffix" &&
          key !== "price_per_pillar_user" &&
          key !== "number_of_pillar_users"
      )
    ) {
      toast.error("Not all mandatory fields are filled out", toast_values);
      return;
    }
    if (
      pillarSubscription["subscription_stopped"] &&
      new Date(pillarSubscription["subscription_started"]) > new Date(pillarSubscription["subscription_stopped"])
    ) {
      toast.error("End date should be after start date", toast_values);
      return;
    }
    const postdata = {
      type: pillarSubscription.type,
      wefact_merchant_id: pillarSubscription.wefact_merchant_id,
      name: pillarSubscription.name,
      subscription_started: pillarSubscription.subscription_started,
      subscription_stopped:
        pillarSubscription.subscription_stopped === "" ? null : pillarSubscription.subscription_stopped,
      period: pillarSubscription.period,
      invoice_type: pillarSubscription.invoice_type,
      number_suffix: pillarSubscription.number_suffix === "" ? null : pillarSubscription.number_suffix,
      price_per_pillar_user:
        pillarSubscription.price_per_pillar_user === "" ? null : pillarSubscription.price_per_pillar_user,
      number_of_pillar_users:
        pillarSubscription.number_of_pillar_users === "" ? null : pillarSubscription.number_of_pillar_users,
    };
    _post("/nova/merchant/" + merchantId + "/subscription", postdata)
      .then((response) => {
        toast.success("New " + pillarSubscription.type + " subscription added!", toast_values);
        console.log(response.data);
        props.subscriptions.push(response.data);
        props.setSubscriptions(_.cloneDeep(props.subscriptions));
        closeDialog();
      })
      .catch((error) => {
        toast.error("New " + pillarSubscription.type + " subscription could not be added.", toast_values);
        console.error(error);
        return Promise.reject(error);
      });
  };

  // subscription dialog functions

  const onceSubscriptionDialog = () => {
    if (onceSubscription == null || tspMerchants == null) {
      initializeOnce();
      loadTspMerchants();
      return (
        <div align="center">
          <CircularProgress color="primary" />
        </div>
      );
    }
    return (
      <Dialog open={props.dialogType === "once"} onClose={closeDialog}>
        <DialogTitle>Adding a new subscription: ONCE</DialogTitle>
        <DialogContent>
          <DialogContentText>Please choose a debtor and merchant and fill in most fields. The</DialogContentText>
          <FormControl style={{ margin: "1em" }}>
            <InputLabel>debtor</InputLabel>
            <Select
              value={onceSubscription.debtor_code}
              label="debtor"
              onChange={(event) => changeOnce("debtor_code", event.target.value)}
            >
              {props.wefactMerchants.map((merch) => {
                return (
                  <MenuItem value={merch.debtor_code} key={merch.debtor_code}>
                    {merch.debtor_code ? merch.debtor_code + " " + merch.name : "                "}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <TextField
            label="title"
            variant="filled"
            type="text"
            style={{ margin: "1em" }}
            value={onceSubscription.title}
            onChange={(event) => changeOnce("title", event.target.value)}
          />
          <TextField
            label="date"
            style={{ margin: "1em" }}
            variant="filled"
            type="date"
            value={onceSubscription.date}
            onChange={(event) => changeOnce("date", event.target.value)}
          />
          <TextField
            label="number"
            style={{ margin: "1em" }}
            variant="filled"
            type="number"
            inputMode="numeric"
            value={onceSubscription.number}
            onChange={(event) => changeOnce("number", event.target.value)}
            inputProps={{
              min: 0,
            }}
          />
          <TextField
            label="type"
            style={{ margin: "1em" }}
            variant="filled"
            type="text"
            value={onceSubscription.type}
            onChange={(event) => changeOnce("type", event.target.value)}
          />
          <FormControl variant="outlined" style={{ margin: "1em" }}>
            <InputLabel>price</InputLabel>
            <OutlinedInput
              type="number"
              inputMode="decimal"
              startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
              labelWidth={30}
              onChange={(event) => changeOnce("price", event.target.value)}
              value={onceSubscription.price}
              inputProps={{
                min: 0,
                step: 0.01,
              }}
            />
          </FormControl>
          <FormControl style={{ margin: "1em" }}>
            <InputLabel>merchant</InputLabel>
            <Select
              value={onceSubscription.tsp_merchant_id}
              label="merchant"
              onChange={(event) => changeOnce("tsp_merchant_id", event.target.value)}
            >
              {tspMerchants.map((merch) => {
                return (
                  <MenuItem value={merch} key={merch}>
                    {merch}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button style={{ margin: "1em" }} onClick={closeDialog}>
            Cancel
          </Button>
          <Button style={{ margin: "1em" }} onClick={addOnce}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const QRSubscriptionDialog = (type) => {
    if (tspMerchants == null) {
      loadTspMerchants();
      return load();
    }
    if (qrSubscription == null || qrSubscription.type !== type) {
      initializeQR(type);
      return load();
    }
    return (
      <Dialog open={true}>
        <DialogTitle>Adding new subscription: {qrSubscription.type}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please fill in most fields. The 'end date', 'number', 'type', 'price' and 'discount percentage' are optional
            fields.
          </DialogContentText>
          <Grid container direction={"row"} spacing={3}>
            <Grid item>
              <FormControl>
                <InputLabel>debtor</InputLabel>
                <Select
                  value={qrSubscription.wefact_merchant_id}
                  onChange={(event) => changeQR("wefact_merchant", event.target.value)}
                >
                  {props.wefactMerchants.map((merchant) => {
                    return <MenuItem value={merchant.id}>{merchant.debtor_code + " " + merchant.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              {(() => {
                if (type === "TA_QR") {
                  return (
                    <FormControl>
                      <InputLabel>TA_merchant</InputLabel>
                      <Select
                        value={qrSubscription.ta_merchant_id}
                        onChange={(event) => changeQR("ta_merchant_id", event.target.value)}
                      >
                        {props.merchant.ta_merchants.map((ta_merchant) => {
                          return <MenuItem value={ta_merchant.id}>{"T" + ta_merchant.id}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  );
                } else {
                  return (
                    <FormControl>
                      <InputLabel>SP_merchant</InputLabel>
                      <Select
                        value={qrSubscription.sp_merchant_id}
                        onChange={(event) => changeQR("sp_merchant_id", event.target.value)}
                      >
                        {props.merchant.sp_merchants.map((sp_merchant) => {
                          return <MenuItem value={sp_merchant.id}>{"S" + sp_merchant.id}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  );
                }
              })()}
            </Grid>
            <Grid item>
              <TextField
                label="title"
                value={qrSubscription.name}
                onChange={(event) => changeQR("name", event.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <TextField
                label="start date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => changeQR("subscription_started", event.target.value)}
                value={qrSubscription.subscription_started}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <TextField
                label="end date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => changeQR("subscription_stopped", event.target.value)}
                value={(() => {
                  if (qrSubscription.subscription_stopped == null) return "";
                  return qrSubscription.subscription_stopped;
                })()}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <FormControl>
                <InputLabel>period</InputLabel>
                <Select value={qrSubscription.period} onChange={(event) => changeQR("period", event.target.value)}>
                  {qr_periods.map((period) => {
                    return <MenuItem value={period}>{period}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl>
                <InputLabel>invoice type</InputLabel>
                <Select
                  value={qrSubscription.invoice_type}
                  onChange={(event) => changeQR("invoice_type", event.target.value)}
                >
                  {qr_invoice_types.map((period) => {
                    return <MenuItem value={period}>{period}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl variant="outlined">
                <InputLabel>number</InputLabel>
                <OutlinedInput
                  type="number"
                  labelWidth={60}
                  inputMode="numeric"
                  onChange={(event) =>
                    changeQR("meta number_of_qrs", event.target.value ? parseInt(event.target.value) : null)
                  }
                  value={qrSubscription.meta.number_of_qrs ? qrSubscription.meta.number_of_qrs : ""}
                  inputProps={{
                    min: 0,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <TextField
                label="type"
                type="text"
                onChange={(event) => changeQR("meta number_suffix", event.target.value ? event.target.value : null)}
                value={qrSubscription.meta.number_suffix ? qrSubscription.meta.number_suffix : ""}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <FormControl variant="outlined">
                <InputLabel>price</InputLabel>
                <OutlinedInput
                  type="number"
                  inputMode="decimal"
                  startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
                  labelWidth={33}
                  onChange={(event) =>
                    changeQR("meta price_per_qr", event.target.value ? parseFloat(event.target.value) : null)
                  }
                  value={qrSubscription.meta.price_per_qr ? qrSubscription.meta.price_per_qr : ""}
                  inputProps={{
                    min: 0,
                    step: 0.01,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl variant="outlined">
                <InputLabel>discount percentage</InputLabel>
                <OutlinedInput
                  type="number"
                  inputMode="decimal"
                  endAdornment={<InputAdornment position="end">{"%"}</InputAdornment>}
                  labelWidth={150}
                  onChange={(event) =>
                    changeQR("meta discount_percentage", event.target.value ? parseFloat(event.target.value) : null)
                  }
                  value={qrSubscription.meta.discount_percentage ? qrSubscription.meta.discount_percentage : ""}
                  inputProps={{
                    min: 0,
                    step: 0.01,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  changeQR("subscription_stopped", null);
                }}
              >
                Empty end date
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()}>Cancel</Button>
          <Button onClick={() => addQR()}>Save</Button>
        </DialogActions>
      </Dialog>
    );
  };

  const TCSubscriptionDialog = (type) => {
    if (tspMerchants == null) {
      loadTspMerchants();
      return load();
    }
    if (tcSubscription == null || tcSubscription.type !== type) {
      initializeTC(type);
      return load();
    }
    props.setPaymentSub(tcSubscription);
    return (
      <Dialog open={true} key={tcSubscription}>
        <DialogTitle>Adding new subscription: {tcSubscription.type}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please fill in most fields. The 'end date' and 'count price' fields are optional.
          </DialogContentText>
          <Grid container direction={"row"} spacing={3}>
            <Grid item>
              <FormControl>
                <InputLabel>debtor</InputLabel>
                <Select
                  value={tcSubscription.wefact_merchant_id}
                  onChange={(event) => changeTC("wefact_merchant_id", event.target.value)}
                >
                  {props.wefactMerchants.map((merchant) => {
                    return (
                      <MenuItem value={merchant.id} key={merchant.id}>
                        {merchant.debtor_code + " " + merchant.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              {(() => {
                if (type === "TA_TC") {
                  return (
                    <FormControl>
                      <InputLabel>merchant</InputLabel>
                      <Select
                        value={tcSubscription.ta_merchant_id}
                        onChange={(event) => changeTC("ta_merchant_id", event.target.value)}
                      >
                        {props.merchant.ta_merchants.map((ta_merchant) => {
                          return <MenuItem value={ta_merchant.id}>{"T" + ta_merchant.id}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  );
                } else if (type === "SP_TC") {
                  return (
                    <FormControl>
                      <InputLabel>merchant</InputLabel>
                      <Select
                        value={tcSubscription.sp_merchant_id}
                        onChange={(event) => changeTC("sp_merchant_id", event.target.value)}
                      >
                        {props.merchant.sp_merchants.map((sp_merchant) => {
                          return <MenuItem value={sp_merchant.id}>{"S" + sp_merchant.id}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  );
                } else {
                  return (
                    <FormControl>
                      <InputLabel>merchant</InputLabel>
                      {(() => {
                        const key_ids = ["ta_merchant_id", "sp_merchant_id"];
                        const index = key_ids.findIndex((key) => key in tcSubscription);
                        const mapping = {
                          sp_merchant_id: "S",
                          ta_merchant_id: "T",
                        };
                        return (
                          <Select
                            value={mapping[key_ids[index]] + tcSubscription[key_ids[index]]}
                            onChange={(event) => changeTC("paynl_merchant", event.target.value)}
                          >
                            {props.merchant.sp_merchants.map((sp_merchant) => {
                              return <MenuItem value={"S" + sp_merchant.id}>{"S" + sp_merchant.id}</MenuItem>;
                            })}
                            {props.merchant.ta_merchants.map((ta_merchant) => {
                              return <MenuItem value={"T" + ta_merchant.id}>{"T" + ta_merchant.id}</MenuItem>;
                            })}
                          </Select>
                        );
                      })()}
                    </FormControl>
                  );
                }
              })()}
            </Grid>
            <Grid item>
              <TextField
                label="title"
                value={tcSubscription.name}
                onChange={(event) => changeTC("name", event.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <TextField
                label="start date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => changeTC("subscription_started", event.target.value)}
                value={tcSubscription.subscription_started}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <TextField
                label="end date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => changeTC("subscription_stopped", event.target.value)}
                value={(() => {
                  if (tcSubscription.subscription_stopped == null) return "";
                  return tcSubscription.subscription_stopped;
                })()}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <FormControl>
                <InputLabel>period</InputLabel>
                <Select value={tcSubscription.period} onChange={(event) => changeTC("period", event.target.value)}>
                  {tc_periods.map((period) => {
                    return <MenuItem value={period}>{period}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl>
                <InputLabel>invoice type</InputLabel>
                <Select
                  value={tcSubscription.invoice_type}
                  onChange={(event) => changeTC("invoice_type", event.target.value)}
                >
                  {tc_invoice_types.map((period) => {
                    return <MenuItem value={period}>{period}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              {(() => {
                if (type.includes("TA") || type.includes("SP")) {
                  return (
                    <FormControl variant="outlined">
                      <InputLabel>count price</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
                        labelWidth={33}
                        onChange={(event) =>
                          changeTC("count_price", event.target.value ? parseFloat(event.target.value) : null)
                        }
                        value={tcSubscription.count_price}
                        inputProps={{
                          min: 0,
                          step: 0.01,
                        }}
                      />
                    </FormControl>
                  );
                }
                return (
                  <Button variant="outlined" onClick={openPaymentDialog}>
                    Add payment methods
                  </Button>
                );
              })()}
            </Grid>
            <Grid item>
              <FormControl variant="outlined">
                <InputLabel>VAT</InputLabel>
                <OutlinedInput
                  type="number"
                  inputMode="decimal"
                  endAdornment={<InputAdornment position="end">{"%"}</InputAdornment>}
                  labelWidth={33}
                  onChange={(event) => changeTC("vat", event.target.value ? parseInt(event.target.value) : null)}
                  value={tcSubscription.vat}
                  inputProps={{
                    min: 0,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  changeTC("subscription_stopped", null);
                }}
              >
                Empty end date
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()}>Cancel</Button>
          <Button onClick={() => addTC()}>Save</Button>
        </DialogActions>
      </Dialog>
    );
  };

  const TASubscriptionDialog = (type) => {
    if (tspMerchants == null) {
      loadTspMerchants();
      return load();
    }
    if (taSubscription == null || taSubscription.type !== type) {
      initializeTA(type);
      return load();
    }
    return (
      <Dialog open={true} key={taSubscription}>
        <DialogTitle>Adding new subscription: {taSubscription.type}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please fill in most fields. The 'end date' and 'amount price' fields are optional.
          </DialogContentText>
          <Grid container direction={"row"} spacing={3}>
            <Grid item>
              <FormControl>
                <InputLabel>debtor</InputLabel>
                <Select
                  value={taSubscription.wefact_merchant_id}
                  onChange={(event) => changeTA("wefact_merchant_id", event.target.value)}
                >
                  {props.wefactMerchants.map((merchant) => {
                    return (
                      <MenuItem value={merchant.id} key={merchant.id}>
                        {merchant.debtor_code + " " + merchant.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              {(() => {
                if (type === "TA_TA") {
                  return (
                    <FormControl>
                      <InputLabel>merchant</InputLabel>
                      <Select
                        value={"T" + taSubscription.ta_merchant_id}
                        onChange={(event) => changeTA("ta_merchant_id", event.target.value.slice(1))}
                      >
                        {props.merchant.ta_merchants.map((ta_merchant) => {
                          return <MenuItem value={"T" + ta_merchant.id}>{"T" + ta_merchant.id}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  );
                } else if (type === "SP_TA") {
                  return (
                    <FormControl>
                      <InputLabel>merchant</InputLabel>
                      <Select
                        value={"S" + taSubscription.sp_merchant_id}
                        onChange={(event) => changeTA("sp_merchant_id", event.target.value.slice(1))}
                      >
                        {props.merchant.sp_merchants.map((sp_merchant) => {
                          return <MenuItem value={"S" + sp_merchant.id}>{"S" + sp_merchant.id}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  );
                }
              })()}
            </Grid>
            <Grid item>
              <TextField
                label="title"
                value={taSubscription.name}
                onChange={(event) => changeTA("name", event.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <TextField
                label="start date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => changeTA("subscription_started", event.target.value)}
                value={taSubscription.subscription_started}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <TextField
                label="end date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => changeTA("subscription_stopped", event.target.value)}
                value={(() => {
                  if (taSubscription.subscription_stopped == null) return "";
                  return taSubscription.subscription_stopped;
                })()}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <FormControl>
                <InputLabel>period</InputLabel>
                <Select value={taSubscription.period} onChange={(event) => changeTA("period", event.target.value)}>
                  {ta_periods.map((period) => {
                    return <MenuItem value={period}>{period}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl>
                <InputLabel>invoice type</InputLabel>
                <Select
                  value={taSubscription.invoice_type}
                  onChange={(event) => changeTA("invoice_type", event.target.value)}
                >
                  {ta_invoice_types.map((period) => {
                    return <MenuItem value={period}>{period}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              {(() => {
                if (type.includes("TA") || type.includes("SP")) {
                  return (
                    <FormControl variant="outlined">
                      <InputLabel>amount price</InputLabel>
                      <OutlinedInput
                        type="number"
                        inputMode="decimal"
                        startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
                        labelWidth={33}
                        onChange={(event) =>
                          changeTA("amount_price", event.target.value ? parseFloat(event.target.value) : null)
                        }
                        value={taSubscription.amount_price}
                        inputProps={{
                          min: 0,
                          step: 0.01,
                        }}
                      />
                    </FormControl>
                  );
                }
              })()}
            </Grid>
            <Grid item>
              <FormControl variant="outlined">
                <InputLabel>VAT</InputLabel>
                <OutlinedInput
                  type="number"
                  inputMode="decimal"
                  endAdornment={<InputAdornment position="end">{"%"}</InputAdornment>}
                  labelWidth={33}
                  onChange={(event) => changeTA("vat", event.target.value ? parseInt(event.target.value) : null)}
                  value={taSubscription.vat}
                  inputProps={{
                    min: 0,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  changeTA("subscription_stopped", null);
                }}
              >
                Empty end date
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()}>Cancel</Button>
          <Button onClick={() => addTA()}>Save</Button>
        </DialogActions>
      </Dialog>
    );
  };

  const pillarUserSubscriptionDialog = (type) => {
    if (tspMerchants == null) {
      loadTspMerchants();
      return load();
    }
    if (pillarSubscription == null || pillarSubscription.type !== type) {
      initializePillar(type);
      return load();
    }
    return (
      <Dialog open={true} key={pillarSubscription}>
        <DialogTitle>Adding new subscription: {pillarSubscription.type}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please fill in most fields. The 'number suffix', 'price per pillar user' and 'number of pillar users' fields
            are optional.
          </DialogContentText>
          <Grid container direction={"row"} spacing={3}>
            <Grid item>
              <FormControl>
                <InputLabel>debtor</InputLabel>
                <Select
                  value={pillarSubscription.wefact_merchant_id}
                  onChange={(event) => changePillar("wefact_merchant_id", event.target.value)}
                >
                  {props.wefactMerchants.map((merchant) => {
                    return (
                      <MenuItem value={merchant.id} key={merchant.id}>
                        {merchant.debtor_code + " " + merchant.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              {(() => {
                if (type === "PILLAR_USER") {
                  return (
                    <FormControl>
                      <InputLabel>merchant</InputLabel>
                      <Select
                        value={"P" + pillarSubscription.pillar_subscription_id}
                        onChange={(event) => changePillar("pillar_merchant_id", event.target.value.slice(1))}
                      >
                        {(() => {
                          if (props.merchant.pillar_merchants) {
                            return props.merchant.pillar_merchants.map((pillar_merchant) => {
                              return <MenuItem value={pillar_merchant.id}>{"P" + pillar_merchant.id}</MenuItem>;
                            });
                          }
                          return <div />;
                        })()}
                      </Select>
                    </FormControl>
                  );
                }
              })()}
            </Grid>
            <Grid item>
              <TextField
                label="title"
                value={pillarSubscription.name}
                onChange={(event) => changePillar("name", event.target.value)}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <TextField
                label="start date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => changePillar("subscription_started", event.target.value)}
                value={pillarSubscription.subscription_started}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <TextField
                label="end date"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => changePillar("subscription_stopped", event.target.value)}
                value={(() => {
                  if (pillarSubscription.subscription_stopped == null) return "";
                  return pillarSubscription.subscription_stopped;
                })()}
                variant="outlined"
              />
            </Grid>
            <Grid item>
              <FormControl>
                <InputLabel>period</InputLabel>
                <Select
                  value={pillarSubscription.period}
                  onChange={(event) => changePillar("period", event.target.value)}
                >
                  {pillar_periods.map((period) => {
                    return <MenuItem value={period}>{period}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl>
                <InputLabel>invoice type</InputLabel>
                <Select
                  value={pillarSubscription.invoice_type}
                  onChange={(event) => changePillar("invoice_type", event.target.value)}
                >
                  {pillar_invoice_types.map((period) => {
                    return <MenuItem value={period}>{period}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => {
                  changePillar("subscription_stopped", null);
                }}
              >
                Empty end date
              </Button>
            </Grid>
            <Grid item>
              <TextField
                variant="outlined"
                label="number suffix"
                onChange={(event) => changePillar("number_suffix", event.target.value)}
                value={pillarSubscription.number_suffix}
              />
            </Grid>
            <Grid item>
              <FormControl variant="outlined">
                <InputLabel>price per pillar user</InputLabel>
                <OutlinedInput
                  type="number"
                  inputMode="decimal"
                  startAdornment={<InputAdornment position="start">{GetCurrency()}</InputAdornment>}
                  labelWidth={160}
                  onChange={(event) =>
                    changePillar("price_per_pillar_user", event.target.value ? parseFloat(event.target.value) : null)
                  }
                  value={pillarSubscription.price_per_pillar_user}
                  inputProps={{
                    min: 0,
                    step: 0.01,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl variant="outlined">
                <InputLabel>number of pillar users</InputLabel>
                <OutlinedInput
                  type="number"
                  inputMode="decimal"
                  labelWidth={160}
                  onChange={(event) =>
                    changePillar("number_of_pillar_users", event.target.value ? parseInt(event.target.value) : null)
                  }
                  value={pillarSubscription.number_of_pillar_users}
                  inputProps={{
                    min: 0,
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => closeDialog()}>Cancel</Button>
          <Button onClick={() => addPillar()}>Save</Button>
        </DialogActions>
      </Dialog>
    );
  };

  // entry point add subscription

  /**
   * This switch statement determines what type of dialog opens for each specific type of subscription.
   */
  switch (props.dialogType) {
    case "once":
      return onceSubscriptionDialog();
    case "ta_qr":
      return QRSubscriptionDialog("TA_QR");
    case "sp_qr":
      return QRSubscriptionDialog("SP_QR");
    case "ta_transaction_amount":
      return TASubscriptionDialog("TA_TA");
    case "sp_transaction_amount":
      return TASubscriptionDialog("SP_TA");
    case "ta_transaction_count":
      return TCSubscriptionDialog("TA_TC");
    case "sp_transaction_count":
      return TCSubscriptionDialog("SP_TC");
    case "paynl_transaction_count":
      return TCSubscriptionDialog("PAYNL_TC");
    case "pillar_user":
      return pillarUserSubscriptionDialog("PILLAR_USER");
    default:
      return <div />;
  }
}
